/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import CopyToClipboard from "react-copy-to-clipboard";
import { Box, SVGIcon, Text, theme } from "@nordcloud/gnui";
import { SUCCESS_TEXT } from "~/constants";
import { showSimpleInfo } from "~/services/toast";

type Props = {
  label: string;
  value: string;
};

export function ReadOnlyField({ label, value }: Props) {
  return (
    <Box
      boxStyle="lightGrey"
      p={theme.spacing.spacing04}
      mb={theme.spacing.spacing02}
      css={{ display: "flex" }}
    >
      <div css={{ flex: 1 }}>
        <Text>
          {" "}
          <span
            css={{
              color: theme.colors.darks[4],
              marginRight: theme.spacing.spacing04,
            }}
          >
            {label}
            {": "}
          </span>
        </Text>
      </div>
      <Text css={{ flex: 6 }}>
        {value}
        <CopyToClipboard
          text={value}
          onCopy={() => {
            showSimpleInfo(SUCCESS_TEXT.copied);
          }}
        >
          <SVGIcon
            name="copy"
            size="sm"
            css={{
              cursor: "pointer",
              marginLeft: theme.spacing.spacing02,
              fill: theme.colors.notification,
            }}
          />
        </CopyToClipboard>
      </Text>
    </Box>
  );
}
